import Service from '@/helpers/adminService'

export default {

    index(params) {
        return Service().get('admin/seminar', {params});
    },
    updateStatus(id, params) {
        return Service().post('admin/seminar/'+id+'/status', params);
    },
    delete(id) {
        return Service().delete('admin/seminar/'+id);
    },
}
